// Central contact & company info — update here to change site-wide.
// User-provided (batiktravelbekasi.id — Bekasi branch)

export const CONTACT = {
  domain: "batiktravelbekasi.id",
  email: "batikumrahhaji.bekasi@gmail.com",
  address_id: "Jaticempaka, Pondok Gede, Bekasi, Jawa Barat",
  address_short: "Jaticempaka, Pondok Gede, Bekasi",
  hours_weekday_id: "Senin - Jumat, 09.00 - 17.00 WIB",
  hours_saturday_id: "Sabtu, 09.00 - 14.45 WIB",
};

// Customer Service team — 4 CS untuk load-balance
export const CS_TEAM = [
  { name: "Hasbi",   number: "6282114294101", display: "+62 821-1429-4101" },
  { name: "Yeyet",   number: "6281932075242", display: "+62 819-3207-5242" },
  { name: "Hasunah", number: "6289508444277", display: "+62 895-0844-4277" },
  { name: "Alfi",    number: "62898863793",   display: "+62 898-8637-933"  },
];

// Primary WA (fallback / display where single number needed)
export const PRIMARY_WA = CS_TEAM[0];

export const waLink = (message = "", number = PRIMARY_WA.number) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
